
// SVG Icon: add
export default { id: "terriajs-add" };
export const id = "terriajs-add";
export const name = "add";
